import { Game } from 'chessboard/model/game/types';

/**
 * Determine if it is an en passant capture.
 */
export function isEPCapture(flags: Game.Move.Flags): boolean {
  return flags === Game.Move.Flags.EPCapture;
}
